import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingIcon = ({ color = 'white', lineHeight = 0, fontSize = 16, size = 'small' }) => {
  const icon = <LoadingOutlined style={{ fontSize }} spin />;
  return <Spin indicator={icon} style={{ color, lineHeight }} size={size} />;
};

export default LoadingIcon;